<template>
  <b-tabs class="d-flex flex-column">
    <b-tab v-if="checkClaim(CAN_VIEW_INVENTORY)">
      <template v-slot:title>
        I/C/E &nbsp;<b-badge variant="primary">{{ inventoryListForPart.length }}</b-badge>
      </template>
      <inventory-list :partId="newPartId" :gridId="getGridId('inventory')" @inventory-created="$emit('refresh-parts')" clearListOnPart hidePostSource isShowCreatePartInventory />
    </b-tab>
    <b-tab v-if="checkClaim(CAN_VIEW_PARTS)">
      <template v-slot:title>
        Alternatives &nbsp;<b-badge variant="primary">{{ alternativesList.length }}</b-badge>
      </template>
      <alternative-list :partId="newPartId" :gridId="getGridId('alternative')" hideUseThis/>
    </b-tab>
    <b-tab>
      <template v-slot:title>
        Allocations &nbsp;<b-badge variant="primary">{{ allocatedParts.length }}</b-badge>
      </template>
      <inventory-allocation :partId="newPartId"/>
    </b-tab>
    <b-tab v-if="checkClaim(CAN_VIEW_PARTS)">
      <template v-slot:title>
        Company Parts &nbsp;<b-badge variant="primary">{{ companyParts.length }}</b-badge>
      </template>
      <company-parts :partId="newPartId" :companyId="0" />
    </b-tab>

    <b-tab v-if="checkClaim(CAN_VIEW_ALL_REQUIREMENTS)">
      <template v-slot:title>
        Requirements &nbsp;<b-badge variant="primary">{{ filteredRequirement.length }}</b-badge>
      </template>
      <requirements :partId="newPartId" :gridId="getGridId('requirement')" clearListOnPart/>
    </b-tab>
    <b-tab v-if="checkClaim(CAN_VIEW_ALL_OFFERS)">
      <template v-slot:title>
        Offers &nbsp;<b-badge variant="primary">{{ offersList.length }}</b-badge>
      </template>
      <offers :partId="newPartId" :gridId="getGridId('offers')" clearListOnPart/>
    </b-tab>
    <b-tab>
      <template v-slot:title>
        Quotes &nbsp;<b-badge variant="primary">{{ quotesFiltered.length }}</b-badge>
      </template>
      <quotes :partId="newPartId" isPartTab />
    </b-tab>
    <b-tab>
      <template v-slot:title>
        Sales Order &nbsp;<b-badge variant="primary">{{ salesOrderLinesByPart.length }}</b-badge>
      </template>
      <sales-orders :partId="newPartId" isPartTab />
    </b-tab>
    <b-tab>
      <template v-slot:title>
        PO &nbsp;<b-badge variant="primary">{{ purchaseorderlines.length }}</b-badge>
      </template>
      <purchase-order-line :partId="newPartId"/>
    </b-tab>
    <b-tab>
      <template v-slot:title>
        Invoices  &nbsp;<b-badge variant="primary">{{ invoicesFiltered.length }}</b-badge>
      </template>
      <invoices :partId="newPartId" isPartTab />
    </b-tab>
    <b-tab v-if="checkClaim(CAN_VIEW_ALL_WORK_ORDERS)">
      <template v-slot:title>
        WO &nbsp;<b-badge variant="primary">{{ serviceOrderLineByPart.length }}</b-badge>
      </template>
      <service-order-lines :partId="newPartId"  isPartTab />
    </b-tab>
    <b-tab>
      <template v-slot:title>
        CRMA &nbsp;<b-badge variant="primary">{{ customerRMALines.length }}</b-badge>
      </template>
      <crma-lines :partId="newPartId"/>
    </b-tab>
    <b-tab title="Vendor RMA">
      <template v-slot:title>
        VRMA &nbsp;<b-badge variant="primary">{{ vrmasListByPart.length }}</b-badge>
      </template>
      <vrma-lines :partId="newPartId"/>
    </b-tab>
    <b-tab>
      <template v-slot:title>
        NCM Report &nbsp;<b-badge variant="primary">{{ ncmReportsByParam.length }}</b-badge>
      </template>
      <ncm-report :partId="newPartId" />
    </b-tab>
    <b-tab>
      <template v-slot:title>
        Inspection Report &nbsp;<b-badge variant="primary">{{ inspectionReportsListByPart.length }}</b-badge>
      </template>
      <inspection-report :partId="newPartId" />
    </b-tab>
    <b-tab title="Documents And Images">
      <documents-and-images :reference="'partId'" :refId="newPartId" :partId="newPartId" clearListOnPart/>
    </b-tab>
  </b-tabs>
</template>

<script>
  import InventoryList from '@/shared/components/InventoryList';
  import PurchaseOrderLine from '@/shared/components/PurchaseOrderLine';
  import Requirements from '@/shared/components/Requirements';
  import Offers from '@/shared/components/Offers';
  import CrmaLines from '@/shared/components/CRMALines';
  import VrmaLines from '@/shared/components/VRMALines';
  import DocumentsAndImages from '@/shared/components/DocumentsAndImages';
  import InventoryAllocation from '@/shared/components/InventoryAllocation';
  import AlternativeList from '@/shared/components/Alternatives';
  import CompanyParts from '@/shared/components/CompanyParts';
  import NcmReport from '@/shared/components/NcmReport';
  import InspectionReport from '@/shared/components/InspectionReport';
  import { GRID_ID } from '@/shared/constants';
  import { mapGetters, mapState } from 'vuex';
  import Quotes from '@/shared/components/Quotes';
  import SalesOrders from '@/shared/components/SalesOrders';
  import Invoices from '@/shared/components/InvoiceLines';
  import ServiceOrderLines from '@/shared/components/ServiceOrderLines';

  export default {
    props: {
      partId: {
        type: [Number, String],
        default: 0,
      },
    },
    components: {
      InventoryList,
      PurchaseOrderLine,
      Requirements,
      Offers,
      CrmaLines,
      VrmaLines,
      DocumentsAndImages,
      InventoryAllocation,
      AlternativeList,
      CompanyParts,
      NcmReport,
      InspectionReport,
      Quotes,
      SalesOrders,
      Invoices,
      ServiceOrderLines
    },
    computed: {
      ...mapState('customerRmasLines', ['customerRMALines']),
      ...mapState('vendorrmas', ['vrmasListByPart']),
      ...mapGetters('ncmReports', ['ncmReportsByParam']),
      ...mapGetters('offers', ['offersList']),
      ...mapGetters('requirements', ['filteredRequirement']),
      ...mapGetters('purchaseorders', ['purchaseOrderLines']),
      ...mapGetters('companyParts', { companyParts: 'gridList'}),
      ...mapGetters('alternatives', ['alternativesList']),
      ...mapGetters('inspectionReports', ['inspectionReportsListByPart']),
      ...mapGetters('inventory', ['inventoryListForPartById', 'allocatedParts']),
      ...mapGetters('quotes', ['quotesFiltered']),
      ...mapGetters('invoices', [ 'invoicesFiltered' ]),
      ...mapGetters('salesOrderLines', ['salesOrderLinesByPart']),
      ...mapGetters('serviceOrderLines', ['serviceOrderLineByPart']),
      inventoryListForPart() {
        return this.inventoryListForPartById(this.newPartId);
      },
      newPartId() {
        return this.$route.params.id || this.partId;
      },
    },
    methods: {
      getGridId(tabName) {
        switch (tabName) {
          case 'inventory':
            return GRID_ID.ADD_REQUIREMENT_INVENTORY_LIST;
            break;
          case 'requirement':
            return GRID_ID.PARTS_REQUIREMENTS;
            break;
          case 'offers':
            return GRID_ID.REQUIREMENT_OFFERS;
            break;
          case 'alternative':
            return GRID_ID.REQUIREMENT_ALTERNATIVES
            break;
        }
      },
    },
    mounted() {},
    updated() {
      //console.log('lastOpenedId in lower tab', this.newPartId);
    },
  };
</script>
